import styled, { keyframes } from 'styled-components';
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import {useWindowSize} from "@repo/ui";

const slideAnim = keyframes`
    from {
        transform: translateY(0%);
    }
    to {
        transform: translateY(-100%);
    }
`;

export const Looper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    overflow: hidden;
`;

export const LooperInnerList = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    height: fit-content;
    &[data-animate="true"] {
        .looper__listInstance {
            animation: ${slideAnim} linear infinite;
        }

        &:hover .looper__listInstance {
            animation-play-state: paused;
        }
    }
`;

export const LooperListInstance = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    animation: none;
`;

const InfiniteLooper = ({ numberOfItems, speed, direction, disabled, children }) => {
    const [looperInstances, setLooperInstances] = useState(1);
    const [animationDuration, setAnimationDuration] = useState(speed);
    const outerRef = useRef(null);
    const innerRef = useRef(null);
    const selectedItem = useSelector((state) => state.menu.selectedItem);

    function resetAnimation() {
        if (innerRef?.current) {
            innerRef.current.setAttribute('data-animate', 'false');

            setTimeout(() => {
                if (innerRef?.current) {
                    innerRef.current.setAttribute('data-animate', 'true');
                }
            }, 10);
        }
    }

    const setupInstances = useCallback(() => {
        if (!innerRef?.current || !outerRef?.current) return;
        const { height } = innerRef.current.getBoundingClientRect();
        const { height: parentHeight } = outerRef.current.getBoundingClientRect();
        const heightDeficit = parentHeight - height;
        const instanceHeight = height / innerRef.current.children.length;

        if (heightDeficit > 0) {
            setLooperInstances(
                looperInstances + Math.ceil(heightDeficit / instanceHeight) + 1
            );
        }

        setAnimationDuration((height/parentHeight) * speed)
        resetAnimation();
    }, [numberOfItems, speed, selectedItem]);

    useEffect(() => setupInstances(), [setupInstances, selectedItem]);

    useEffect(() => {
        window.addEventListener('resize', setupInstances);

        return () => {
            window.removeEventListener('resize', setupInstances);
        };
    }, [looperInstances, setupInstances]);



    return numberOfItems > 0 ? (
        <Looper ref={outerRef}>
            <LooperInnerList ref={innerRef} data-animate="true">
                {[...Array(3)].map((_, ind) => (
                    <LooperListInstance
                        key={ind}
                        className="looper__listInstance"
                        style={!disabled ? {
                            animationDuration: `${animationDuration}s`,
                            animationDirection: direction === 'down' ? 'reverse' : 'normal',
                        } : {}}
                    >
                        {children}
                    </LooperListInstance>
                ))}
            </LooperInnerList>
        </Looper>
    ) : null;
};

export default InfiniteLooper;